<template>
    <div>
        <div class="smallContent miscContent">
            <div v-show="getState == '1' || getState == '2'" class="block2">
                <p>Support Montez Press Radio</p>
                <div class="space"></div>

                <p>
                    Montez Press Radio is ad-free and dependent on donations and
                    the support of its listeners. Subscribers of Montez Press
                    Radio get unlimited access to our evergrowing archive of
                    shows.
                </p>
                <div class="space"></div>
                <p>
                    At MPR we believe paying artists for their work is
                    important. Sign up as a Supporter to help pay an artist, and
                    you’ll receive a special gift from MPR as a token of our
                    appreciation.
                </p>
            </div>
            <div v-show="getState == '1a' || getState == '2a'" class="block2">
                <!--
        <p>Support Montez Press Radio for another year</p>
        <div class="space"></div>
        <p>Choose your support plan according to your financial possibilites:</p>
        -->

                <p>
                    Thank you for supporting Montez Press Radio. Your
                    subscription will renew automatically on {{ getRenewDate }}.
                    To quit your subscription, you can do so by logging in to
                    your Paypal account. If you have any questions on your
                    subscription, please contact us:
                    <a href="mailto:support@montezpress.com"
                        >support@montezpress.com</a
                    >
                </p>
                <p>
                    To make an additional donation, please click
                    <a
                        href="https://www.paypal.com/donate/?cmd=_s-xclick&hosted_button_id=SSUW4WD7HN8YU&source=url"
                        target="_blank"
                        >here</a
                    >.
                </p>
            </div>
            <div v-show="getState == '5'" class="block">
                <p>Checkout</p>
                <div class="space"></div>
                <p>Please review your annual support plan:</p>
            </div>
            <div v-show="getState == '5a'" class="block">
                <p>Checkout</p>
                <div class="space"></div>
                <p>Please review your renewal plan:</p>
            </div>
            <div v-show="getState == '5b'" class="block">
                <p>
                    Thank you for your registration. Please check your emails to
                    confirm your email address and proceed to checkout.
                </p>
                <p>
                    Didn’t receive an email? Please contact us:
                    <a href="mailto:support@montezpress.com"
                        >support@montezpress.com</a
                    >
                </p>
            </div>
            <div
                v-show="
                    getState == '1' ||
                    getState == '2' ||
                    getState == '5' ||
                    getState == '5a'
                "
                id="choose"
                class="block"
            >
                <div
                    class="plan"
                    @click="choosePlan('planRegMonth')"
                    :class="{ active: store.plan == 'planRegMonth' }"
                >
                    Monthly Subscription<br />
                    $5 / month (billed monthly)
                </div>
                <div
                    class="plan"
                    @click="choosePlan('planRegYear')"
                    :class="{ active: store.plan == 'planRegYear' }"
                >
                    Annual Subscription<br />
                    $4 / month (billed anually)
                </div>
                <div
                    class="plan"
                    @click="choosePlan('planStudYear')"
                    :class="{ active: store.plan == 'planStudYear' }"
                >
                    Student Subscription*<br />
                    $2 / month (billed anually)
                </div>
                <div
                    class="plan"
                    @click="choosePlan('planSupYear')"
                    :class="{ active: store.plan == 'planSupYear' }"
                >
                    Supporter Subscription<br />
                    $8 / month (billed anually)
                </div>

                <div
                    class="plan"
                    @click="choosePlan('planDonYear')"
                    :class="{ active: store.plan == 'planDonYear' }"
                >
                    Donor Subscription<br />
                    $80 / month (billed anually)
                </div>
                <p id="subPlan">*Only for students and unwaged.</p>
                <div v-if="!store.plan">
                    <div class="space"></div>
                    <p>
                        If you prefer to give a one-time donation without
                        subscribing to our archive you can do so here. All
                        donations are tax-deductible to the fullest extent of
                        the law. If you want to listen to the archive, choose an
                        annual support plan above.
                    </p>

                    <form
                        id="donate"
                        target="_blank"
                        action="https://www.paypal.com/cgi-bin/webscr"
                        method="post"
                    >
                        <input type="hidden" name="cmd" value="_s-xclick" />
                        <input
                            type="hidden"
                            name="hosted_button_id"
                            value="SSUW4WD7HN8YU"
                        />
                        <input id="donateSubmit" type="submit" value="Donate" />
                    </form>
                </div>
                <!--
        <form @submit.prevent="pay">
            <input type="submit" value="Pay">
        </form>
            --></div>
            <div v-show="getState == '3'" class="block">
                <p>
                    Thank you for your registration. Please check your emails to
                    confirm your email address and proceed to checkout.
                </p>
                <p>
                    Didn’t receive an email? Please contact us:
                    <a href="mailto:support@montezpress.com"
                        >support@montezpress.com</a
                    >
                </p>
            </div>

            <div
                v-show="
                    (this.store.plan != '25' && getState == '2') ||
                    getState == '5' ||
                    getState == '5b'
                "
                id="present"
                class="block"
            >
                <div
                    v-if="
                        this.store.plan == 'planSupYear' ||
                        this.store.plan == 'planDonYear'
                    "
                    id="choosePresent"
                >
                    <p>Our gift to you:</p>
                    <div class="labelText">
                        <input
                            type="radio"
                            name="gift"
                            v-bind:value="true"
                            v-model="gift_wanted"
                            checked
                            id="gift"
                        />
                        <label for="gift">
                            <div class="labelImage"></div>
                            <span
                                v-if="
                                    this.store.plan == 'planSupYear' &&
                                    this.store.presentSup.text
                                "
                                v-html="this.store.presentSup.text"
                            ></span>
                            <span
                                v-if="
                                    this.store.plan == 'planDonYear' &&
                                    this.store.presentDon.text
                                "
                                v-html="this.store.presentDon.text"
                            ></span>
                        </label>
                    </div>
                    <img
                        v-if="
                            this.store.plan == 'planSupYear' &&
                            this.store.presentSup.image
                        "
                        :src="this.store.presentSup.image"
                        alt=""
                    />
                    <img
                        v-if="
                            this.store.plan == 'planDonYear' &&
                            this.store.presentDon.image
                        "
                        :src="this.store.presentDon.image"
                        alt=""
                    />
                    <div class="labelText">
                        <input
                            type="radio"
                            name="gift"
                            v-bind:value="false"
                            v-model="gift_wanted"
                            id="noGift"
                        />
                        <label for="noGift">
                            <div class="labelImage"></div>

                            <span>
                                No thank you, I don’t want a gift.<br />
                                Please send my full support to artists.
                            </span>
                        </label>
                    </div>
                </div>
            </div>

            <div v-show="getState == '2'" id="register" class="block">
                <p class="p2">
                    To become a supporter, please register first. If you already
                    have an account, please
                    <router-link :to="{ name: 'login' }">login</router-link>.
                </p>
                <form @submit.prevent="register">
                    <input
                        type="text"
                        v-model="username"
                        placeholder="Username"
                        required
                    /><br />
                    <input
                        type="email"
                        v-model="email"
                        placeholder="Email"
                        required
                    /><br />
                    <input
                        type="password"
                        v-on:change="checkPass"
                        v-model="password"
                        placeholder="Password"
                        required
                    /><br />
                    <input
                        type="password"
                        v-model="repeatPassword"
                        v-on:change="checkPass"
                        ref="repeatPass"
                        placeholder="Repeat password"
                        required
                    /><br />
                    <input
                        type="submit"
                        :class="{ valid: passIdentical }"
                        value="Proceed"
                    />
                </form>
            </div>

            <!--
        <div v-show="getState == '2a'" class="block">
            <div class="proceed" @click="proceeded=true">Proceed</div>
        </div>
    -->

            <div v-show="getState == '5' || getState == '5a'" class="block">
                <div v-show="renderButton" id="paypal-button-container"></div>
            </div>

            <div v-show="getState == '6'" class="block">
                <img id="thankyou" src="/static/Thankyou2.jpg" />
            </div>

            <img
                v-if="loading"
                id="spinner"
                src="/static/icons/spinner-large.svg"
                alt=""
            />
            <p v-if="message" id="message">{{ message }}</p>
        </div>
        <Footer></Footer>
    </div>
</template>

<script>
import axios from "axios";
import { store } from "../store";
import { DateTime, Interval } from "luxon";
import Footer from "./Footer.vue";
import { loadScript } from "@paypal/paypal-js";

export default {
    name: "Subscribe",
    components: {
        Footer,
    },
    data() {
        return {
            username: "",
            email: "",
            password: "",
            repeatPassword: "",
            passIdentical: false,
            store: store,
            message: null,
            paypal: null,
            hash: "",
            loading: false,
            plan25ID: "P-4NJ60847AB6097629MSC3SHI",
            plan50ID: "P-39W512604R3957035MSGOLSA",
            plan100ID: "P-0AU52994JV7659933MSGOMBI",
            plan1000ID: "P-1UF57188DY769121WMSGOLFY",
            currentPlan: "P-9MJ302138Y342274JNIZMAGA",
            planRegMonth: "P-9MJ302138Y342274JNIZMAGA",
            planRegYear: "P-28S97153H2367590YNIZMBSI",
            planStudYear: "P-1HD80353TA5927740NIZMB7I",
            planSupYear: "P-20G44876SD5026546NIZMCIA",
            planDonYear: "P-6JA960219C934721HNIZMCPI",
            renderButton: true,
            error: false,
            allowPay: true,
            checkedOut: false,
            fromEmail: false,
            proceeded: false,
            paypal_email: "",
            gift_wanted: true,
        };
    },
    computed: {
        getRenewDate() {
            let now = DateTime.utc();
            let payed = DateTime.fromISO(this.store.lastPayed);
            //let interval = Interval.fromDateTimes(payed, now)
            let newDate = payed.plus({ days: 365 });
            return newDate.toFormat("LLLL d yyyy");
        },
        showRegister() {
            if (!store.authenticated && this.store.plan) {
                return true;
            } else {
                return false;
            }
        },
        showPresent() {
            let now = DateTime.utc();
            let payed = DateTime.fromISO(this.store.lastPayed);
            let interval = Interval.fromDateTimes(payed, now);
            if (
                this.store.authenticated &&
                this.store.giftEligible &&
                !this.error &&
                this.store.confirmed
            ) {
                return true;
            } else {
                return false;
            }
        },
        showPay() {
            if (
                this.store.authenticated &&
                !this.error &&
                this.store.confirmed &&
                this.allowPay
            ) {
                return true;
            } else {
                return false;
            }
        },
        getState() {
            let state;
            if (this.checkedOut) {
                state = "6";
            } else if (this.fromEmail) {
                state = "5";
            } else if (this.store.valid) {
                state = "1a";
            } else if (
                this.store.authenticated &&
                this.store.confirmed &&
                this.proceeded
            ) {
                state = "5a";
            } else if (
                this.store.authenticated &&
                !this.store.confirmed &&
                this.proceeded
            ) {
                state = "5b";
            } else if (this.proceeded) {
                state = "3";
            } else if (this.store.plan && !this.store.authenticated) {
                state = "2";
            } else if (this.store.plan && this.store.authenticated) {
                state = "3";
            } else if (this.store.authenticated) {
                state = "3";
            } else {
                state = "1";
            }
            console.log("checkout state", state);
            return state;
        },
    },
    methods: {
        confirmEmail() {
            let myself = this;
            myself.message = "";
            axios.defaults.headers.common["X-CSRFToken"] =
                this.getCookie("csrftoken");
            axios
                .post("/api/confirm-email", { hash: this.$route.params.hash })
                .then((response) => {
                    if (response.data.detail == "Success") {
                        localStorage.setItem("authenticated", "success");
                        localStorage.setItem("confirmed", "true");
                        myself.store.confirmed = true;
                        myself.store.authenticated = true;
                        myself.store.userID = response.data.user_id;
                        myself.error = false;
                    } else {
                        myself.error = true;
                    }
                    myself.message = response.data.message;
                    myself.store.plan = response.data.plan;
                    myself.fromEmail = true;
                    myself.choosePlan(myself.store.plan);
                });
        },
        choosePlan(amount) {
            this.renderButton = false;
            let myself = this;
            this.store.plan = amount;
            setTimeout(function () {
                myself.plan = amount;
                if (amount == "planRegMonth") {
                    myself.currentPlan = myself.planRegMonth;
                } else if (amount == "planRegYear") {
                    myself.currentPlan = myself.planRegYear;
                } else if (amount == "planStudYear") {
                    myself.currentPlan = myself.planStudYear;
                } else if (amount == "planSupYear") {
                    myself.currentPlan = myself.planSupYear;
                } else if (amount == "planDonYear") {
                    myself.currentPlan = myself.planDonYear;
                }
                myself.renderButton = true;
                //console.log(myself.store.plan);
                //console.log(myself.currentPlan);
                // setTimeout(function () {
                //     myself.renderButtons();
                // }, 200);
            }, 200);
        },
        checkPass() {
            if (this.password == this.repeatPassword) {
                this.$refs.repeatPass.setCustomValidity("");
                this.passIdentical = true;
            } else {
                this.$refs.repeatPass.setCustomValidity(
                    "Passwords don't match"
                );
                this.passIdentical = false;
            }
        },
        getCookie(cname) {
            var name = cname + "=";
            var decodedCookie = decodeURIComponent(document.cookie);
            var ca = decodedCookie.split(";");
            for (var i = 0; i < ca.length; i++) {
                var c = ca[i];
                while (c.charAt(0) == " ") {
                    c = c.substring(1);
                }
                if (c.indexOf(name) == 0) {
                    return c.substring(name.length, c.length);
                }
            }
            return "";
        },
        paySuccess() {
            let myself = this;
            myself.message = "";
            myself.loading = true;
            axios.defaults.headers.common["X-CSRFToken"] =
                this.getCookie("csrftoken");
            axios
                .post("/api/pay", {
                    user_id: this.store.userID,
                    plan: myself.currentPlan,
                    paypal_email: myself.paypal_email,
                })
                .then((response) => {
                    if ("detail" in response.data) {
                        if (response.data.detail == "Success") {
                            localStorage.setItem(
                                "lastPayed",
                                response.data.last_payed
                            );
                            localStorage.setItem(
                                "giftEligible",
                                response.data.gift_eligible
                            );
                            myself.store.lastPayed = response.data.last_payed;
                            myself.store.giftEligible =
                                response.data.gift_eligible;
                            myself.store.valid = true;
                            myself.allowPay = false;
                        }
                        //myself.message = response.data.message
                        myself.loading = false;
                        myself.checkedOut = true;
                        myself.proceeded = false;
                    }
                });
        },
        register() {
            let myself = this;
            myself.loading = true;
            myself.message = "";
            axios.defaults.headers.common["X-CSRFToken"] =
                this.getCookie("csrftoken");
            axios
                .post("/api/register", {
                    username: this.username,
                    password: this.password,
                    email: this.email,
                    plan: myself.currentPlan,
                    gift_wanted: this.gift_wanted,
                })
                .then((response) => {
                    if (response.data.detail == "Success") {
                        localStorage.setItem(
                            "giftEligible",
                            response.data.gift_eligible
                        );
                        localStorage.setItem("userID", response.data.user_id);
                        myself.store.giftEligible = response.data.gift_eligible;
                        myself.store.userID = response.data.user_id;
                        //myself.hash = response.data.hash
                        myself.proceeded = true;
                    } else {
                        myself.message = response.data.message;
                    }
                    myself.loading = false;
                });
        },
        // renderButtons() {
        //     let myself = this;
        //     if (this.paypal) {
        //         this.paypal
        //             .Buttons({
        //                 style: {
        //                     shape: "rect",
        //                     color: "white",
        //                     layout: "vertical",
        //                     label: "subscribe",
        //                 },
        //                 createSubscription: function (data, actions) {
        //                     return actions.subscription.create({
        //                         plan_id: myself.currentPlan,
        //                     });
        //                 },
        //                 onApprove: function (data, actions) {
        //                     console.log(data);
        //                     myself.paypal_email = data.subscriptionID;
        //                     myself.paySuccess();
        //                 },
        //                 onCancel: function (data) {
        //                     myself.message = "You canceled the payment.";
        //                 },
        //                 onError: function (data) {
        //                     console.log(data);
        //                     if (
        //                         myself.getState == "5" ||
        //                         myself.getState == "5a"
        //                     ) {
        //                         myself.message =
        //                             "Something went wrong, please contact our Support.";
        //                     }
        //                 },
        //             })
        //             .render("#paypal-button-container");
        //     }
        // },
    },
    created() {
        axios.get("/api/login-set-cookie");
    },
    mounted() {
        // const plugin = document.createElement("script");
        // plugin.setAttribute(
        //     "src",
        //     "https://www.paypal.com/sdk/js?client-id=AQZjWrT3uwzJbqHRdCf8V6GKWpffvqD_lUEY4fvxUJhRe2mkmUOUMUw9Cpa64ySnJBYBfVh_J3J_aW3I&vault=true&intent=subscription"
        // );
        // plugin.setAttribute("data-sdk-integration-source", "button-factory");

        // plugin.async = true;
        // plugin.onload = () => {
        //     this.paypal = paypal;
        //     this.renderButtons();
        // };
        // document.head.appendChild(plugin);
        if (this.$route.params.hash) {
            this.confirmEmail();
        }
    },
    activated() {
        this.message = "";
        let myself = this;
        // this.renderButtons();
        loadScript({
            "client-id":
                "AQZjWrT3uwzJbqHRdCf8V6GKWpffvqD_lUEY4fvxUJhRe2mkmUOUMUw9Cpa64ySnJBYBfVh_J3J_aW3I&vault=true&intent=subscription",
        }).then((paypal) => {
            paypal
                .Buttons({
                    style: {
                        shape: "rect",
                        color: "white",
                        layout: "vertical",
                        label: "subscribe",
                    },
                    createSubscription: function (data, actions) {
                        return actions.subscription.create({
                            plan_id: myself.currentPlan,
                        });
                    },
                    onApprove: function (data, actions) {
                        console.log(data);
                        myself.paypal_email = data.subscriptionID;
                        myself.paySuccess();
                    },
                    onCancel: function (data) {
                        myself.message = "You canceled the payment.";
                    },
                    onError: function (data) {
                        console.log(data);
                        if (myself.getState == "5" || myself.getState == "5a") {
                            myself.message =
                                "Something went wrong, please contact our Support.";
                        }
                    },
                })
                .render("#paypal-button-container");
        });
    },
};
</script>

<style scoped>
p {
    margin-top: 0.5rem;
    margin-bottom: 0.7rem;
}

p:first-child {
    margin-top: 0;
}
.p2 {
    margin-bottom: 0.8rem;
}

a {
    color: #aaaaaa;
    cursor: pointer;
}
a:hover {
    color: black;
}

input.unident {
    border: 1px solid red;
}
#message {
    margin-top: 1rem;
}
#present > img {
    width: 100%;
}
#present {
}
#spinner {
    margin: 0.5rem calc(50% - 1rem) 1rem;
    max-width: 3rem;
}
.plan {
    width: 100%;
    border: 1px solid black;
    padding: 0.65rem 1rem 0.85rem;
    text-align: center;
    margin-bottom: 1rem;
    box-sizing: border-box;
    cursor: pointer;
}
.plan:last-of-type {
    margin-bottom: 0;
}
.proceed {
    width: 100%;
    border: 1px solid black;
    padding: 0.5rem 1rem;
    text-align: center;
    margin-top: 2rem;
    box-sizing: border-box;
    cursor: pointer;
    color: white;
    background-color: black;
}
.plan.active,
.plan:hover {
    color: white;
    background-color: black;
}
input[type="submit"] {
    cursor: pointer;
    color: black;
    background-color: white;
    font-family: Montez Large !important;
    font-style: normal !important;
    font-weight: 100 !important;
}
input[type="submit"]:hover {
    color: white;
    background-color: black;
}
input[type="submit"].valid {
    color: white;
    background-color: black;
}
#subPlan {
    font-family: "Montez Small";
    font-size: 1rem;
    margin-top: 0.7rem;
}
.block {
    margin-bottom: 1.5rem;
}
.block2 {
    margin-bottom: 1.8rem;
}

img#thankyou {
    max-width: 100%;
    min-width: calc(100vw - 2rem);
    min-height: calc(100vw - 2rem);
    background-color: #d2d2d2;
}
@media only screen and (min-width: 1101px) {
    img#thankyou {
        min-width: calc(66vw - 2rem);
        max-width: calc(66vw - 2rem);
        min-height: calc(66vw - 2rem);
    }
}
@keyframes spin {
    100% {
        transform: rotate(360deg);
    }
}
#spinner {
    animation: spin 1s linear infinite;
}
.space {
    height: 0.3rem;
}
.miscContent {
    width: min(550px, 100%);
}
input[type="radio"] {
    display: none;
}
input[type="radio"]:focus {
}
input[type="radio"]:checked::before {
}
input[type="radio"]:checked {
}
label {
    display: flex;
    flex-direction: row;
    gap: 1rem;
    align-items: flex-start;
    margin: 1rem 0;
    cursor: pointer;
}
input[type="radio"] + label > .labelImage {
    background: url("../assets/check-box.svg") no-repeat;
    height: 1.9rem;
    width: 1.9rem;
    background-size: 100%;
}

input[type="radio"]:checked + label > .labelImage {
    background: url("../assets/check-box-checked.svg") no-repeat;
}
#choosePresent {
    display: flex;
    flex-direction: column;
}
</style>
